import Dropzone from 'components/molecules/functionalities/Dropzone';
import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

const DropzoneInput = ({ values, item }) => {
    const { setFieldValue } = useFormikContext();

    const onFileUploaded = (file) => {
        setFieldValue(item.id, file);
    };

    return <Dropzone onFileUploaded={onFileUploaded} label={item.label} url={values[item.id]} />;
};

DropzoneInput.propTypes = {
    item: PropTypes.object.isRequired,
    values: PropTypes.object
};

export default DropzoneInput;
